import { Radio, RadioGroup } from '@lifeomic/chroma-react/components/Radio';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

export type TemplateExecutionMode = 'standard' | 'tools_loop';

const messages = defineMessages({
  groupTitle: {
    id: 'ReportTemplates.GenerationMenu.toolsLoop.groupTitle',
    defaultMessage: 'Execution',
  },
  standard: {
    id: 'ReportTemplates.GenerationMenu.toolsLoop.standard',
    defaultMessage: 'Standard',
  },
  toolsLoop: {
    id: 'ReportTemplates.GenerationMenu.toolsLoop.toolsLoop',
    defaultMessage: 'Tools Loop',
  },
  toolsLoopHelp: {
    id: 'ReportTemplates.GenerationMenu.toolsLoop.toolsLoopHelp',
    defaultMessage:
      'Beta: Advanced Tool Usage for improved results; longer execution time',
  },
});

type ToolsLoopExecutionSelectProps = {
  value: TemplateExecutionMode;
  onChange: (value: TemplateExecutionMode) => void;
};

export const ToolsLoopExecutionSelect: React.FC<
  ToolsLoopExecutionSelectProps
> = ({ value, onChange }) => {
  const { formatMessage } = useIntl();

  return (
    <RadioGroup
      title={formatMessage(messages.groupTitle)}
      name="templateExecutionMode"
      value={value}
      onChange={e => onChange(e.target.value as TemplateExecutionMode)}
      direction="column"
      align="flex-start"
    >
      <Radio
        value="standard"
        name="templateExecutionMode"
        label={formatMessage(messages.standard)}
      />
      <Radio
        value="tools_loop"
        name="templateExecutionMode"
        label={formatMessage(messages.toolsLoop)}
        helpMessage={formatMessage(messages.toolsLoopHelp)}
      />
    </RadioGroup>
  );
};
